<template lang="pug">
  .dialog-container(id="DialogAddChoice-dialog")
    h4 {{$t('Add to network:')}}
    hr.header
    .buttons-container
      .buttonAdd(id="DialogAddChoice-mediaButton" @click="addChoiceMade('Upload')")
        font-awesome-icon.icon(icon="upload")
        .description {{$t('Media')}}
      .buttonAdd(id="DialogAddChoice-playlistButton" @click="addChoiceMade('PlayList')")
        font-awesome-icon.icon(icon="film")
        .description {{$t('Playlist')}}
      .buttonAdd(id="DialogAddChoice-layoutButton" @click="addChoiceMade('PlayListLayout')")
        font-awesome-icon.icon(icon="layer-group")
        .description {{$t('Layout')}}
      .buttonAdd(id="DialogAddChoice-folderButton" @click="addChoiceMade('PlayListLibrary')")
        font-awesome-icon.icon(icon="folder")
        .description {{$t('Folder')}}
      .buttonAdd(id="DialogAddChoice-extensionButton" @click="addChoiceMade('Extension')")
        font-awesome-icon.icon(icon="code")
        .description {{$t('Extension/Widget')}}
      .buttonAdd(id="DialogAddChoice-htmlButton" @click="addChoiceMade('UploadHTMLzip')")
        font-awesome-icon.icon(icon="file-archive")
        .description {{$t('HTML page')}}
      .buttonAdd(id="DialogAddChoice-fileButton" @click="addChoiceMade('UploadFile')")
        font-awesome-icon.icon(icon="file")
        .description {{$t('Custom file')}}
    hr.header
    .buttons-container
      .buttonAdd(id="DialogAddChoice-screenGroupButton" @click="addChoiceMade('DesktopGroup')")
        font-awesome-icon.icon(icon="chalkboard-teacher")
        .description {{$t('Screens Group')}}
</template>

<script>

export default {
  props: [],
  components: {
  },
  created () {
  },
  data () {
    return {
      errors: {
      }
    }
  },
  methods: {
    addChoiceMade (choice) {
      this.$emit('addChoiceMade', choice)
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "./dialog.scss";
@import "../../../theme-m4b/src/common/var.scss";
.dialog-container {
  .buttons-container {
    display: flex;
    justify-content:space-around;
    .buttonAdd {
      width: 100px;
      height: 100px;
      border: 0px solid blue;
      display: flex;
      flex-direction: column;
      .icon {
        margin: auto;
        width: 50px;
        height: 50px;
        cursor: pointer;
        &:hover {
          color: $--color-text-secondary;
        }
      }
      .description {
        margin: auto;
        color: $--color-text-secondary;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Linker/DialogAddChoice.vue